import * as React from 'react';
// @ts-ignore
import * as Tagify from 'bulma-extensions/bulma-tagsinput/dist/bulma-tagsinput.min';

import './input-field.css';

import { InputHighlight, InputFieldProps } from '../../types';

class InputField extends React.Component<InputFieldProps> {
  private input: React.RefObject<HTMLInputElement> = React.createRef<HTMLInputElement>();
  private observer: MutationObserver;

  public constructor(props: InputFieldProps) {
    super(props);
    props = {
      disabled: false,
      ...props
    };
  }

  public componentDidMount() {
    // Special treatment for `tags` input type. Since bulma-tagsinput creates a separate layer of 
    // input to track individual tags, the `change` event won't be triggered on the parent
    // input (the input that we expect to work with). This uses MutationObserver to observe
    // any change in the inner input element and trigger `change` event on the parent input.
    if (this.props.type === 'tags') {
      // tslint:disable-next-line:no-unused-expression
      new Tagify(this.input.current!);

      if (this.props.onChange || this.props.onBlur) {
        const targetParent = this.input.current!.parentElement!;
        const config = { childList: true, subtree: true };

        this.observer = new MutationObserver(mutationList => 
            mutationList.forEach(() => {
              const tagsinput = targetParent.querySelector('.tagsinput');
              if (tagsinput) {
                // Escape unnecessary typescript check
                if (this.props.onChange) {
                  this.props.onChange({ currentTarget: this.input.current! } as any);
                }
                if (this.props.onBlur) {
                  this.props.onBlur({ currentTarget: this.input.current! } as any);
                }
              }
            })
        );

        this.observer.observe(targetParent, config);
      }
    }
  }

  public componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  public render() {
    const layoutClassName = this.props.layoutClassName || '';
    const inputClassName = this.props.inputClassName || '';

    let highlightClassName = '';
    switch (this.props.highlight) {
      case InputHighlight.CORRECT:
        highlightClassName = 'is-correct'
        break;
      case InputHighlight.DANGER:
        highlightClassName = 'is-danger'
        break;
    }

    return (
      <div className={`field generic-input-wrapper ${layoutClassName}`.trim()}>
        {this.props.label && <label className="field-label generic-input-label">{this.props.label}</label>}
        <div className="control generic-input-control field-body">
          <input
              className={`input generic-input ${highlightClassName} ${inputClassName}`.trim()}
              defaultValue={this.props.defaultValue}
              disabled={this.props.disabled}
              onChange={this.props.onChange}
              onBlur={this.props.onBlur}
              name={this.props.name}
              placeholder={this.props.placeholder}
              // Circumvent bulma-tagsinput's initialiser and use our own componentDidMount to dedup init
              type={this.props.type === 'tags' ? 'text' : this.props.type}
              value={this.props.value}
              ref={this.input}
          />
        </div>
        {this.props.helpMessage && <p className={`help ${highlightClassName}`}>{this.props.helpMessage}</p>}
      </div>
    );
  }
}

export default InputField;



// WEBPACK FOOTER //
// ./src/common/forms/input-field.tsx